import { useMemo } from "react";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { resolveVariableValuesFromStyleObject } from "../Design/getVisualEmailBuilderStyleMap";

export interface ResolvedPadding {
  paddingBottom: number | string;
  paddingLeft: number | string;
  paddingRight: number | string;
  paddingTop: number | string;
}

export const useResolvedButtonPadding = (
  paddingStyleObject: object | null | undefined,
): ResolvedPadding => {
  const currentCanvasTheme = useBuilderStore(state => state.currentCanvasTheme);

  return useMemo(() => {
    const resolved = resolveVariableValuesFromStyleObject({
      styleObject: paddingStyleObject ?? {},
      currentTheme: currentCanvasTheme,
    });

    return {
      paddingTop: resolved.paddingTop ?? 0,
      paddingBottom: resolved.paddingBottom ?? 0,
      paddingLeft: resolved.paddingLeft ?? 0,
      paddingRight: resolved.paddingRight ?? 0,
    };
  }, [paddingStyleObject, currentCanvasTheme]);
};
